<app-modal [id]="modalId">
    <aside class="modal confirm-modal">
      <div class="modal-body">
        <div class="header flex">
            <div class="flex-grow-1"></div>
            <div class="button regular close" (click)="cancel()"><span class="icon">&#x00D7;</span></div>
        </div>
        <div class="content flex" >
            <div class="flex flex-direction-column">
                <h3>{{ options.header }}</h3>
                <p>{{ options.text }}</p>
                <div class="footer">
                    <button (click)="confirm()" class="btn btn-primary">{{ options.confirm }}</button>
                    <a (click)="cancel()">{{ options.cancel }}</a>
                </div>
            </div>
        </div>
      </div>
    </aside>
    <div class="confirm-modal-background"></div>
</app-modal>
